import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faUser,
    faEnvelope,
    faPhone,
    faBookOpen,
    faMessage,
    faPaperPlane,
    faCircleCheck,
    faTriangleExclamation,
    faSpinner,
    faGraduationCap,
    faLeaf,
} from '@fortawesome/free-solid-svg-icons';
import admissionPicture from '../assets/images/admission_picture.jpeg';
import { colleges, courseCount } from '../data/colleges';
import { useEeFormWidget } from '../lib/eeFormWidget';
import './Forms.css';
import './EnquiryWidget.css';

const API_URL =
    'https://m9luhuc58h.execute-api.ap-south-1.amazonaws.com/prod/admissions';

const initialFormState = {
    name: '',
    email: '',
    phone: '',
    course: '',
    message: '',
};

/* The course list comes straight from the colleges data, so the form can never
   drift from the prospectus. `course.id` is the value submitted to the API. */

const AdmissionComponent = () => {
    const [formData, setFormData] = useState(initialFormState);
    const [status, setStatus] = useState({ state: 'idle', message: '' });
    useEeFormWidget('form-3', 'ee-form-3');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus({ state: 'submitting', message: '' });
        try {
            const res = await fetch(API_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
            });
            if (!res.ok) {
                const text = await res.text().catch(() => '');
                throw new Error(`API error: ${res.status} ${text}`);
            }
            setStatus({
                state: 'success',
                message: 'Thanks! Your enquiry is in. Our admissions team will reach out shortly.',
            });
            setFormData(initialFormState);
        } catch (err) {
            setStatus({
                state: 'error',
                message: 'We could not submit your enquiry right now. Please try again in a moment.',
            });
        }
    };

    const isSubmitting = status.state === 'submitting';

    return (
        <>
            <section className="page-hero">
                <span className="blob" aria-hidden="true" />
                <div className="container page-hero-inner">
                    <span className="page-hero-icon">
                        <FontAwesomeIcon icon={faGraduationCap} />
                    </span>
                    <p className="eyebrow">Admissions 2026–27</p>
                    <h1 className="page-hero-title">Start where you're headed</h1>
                    <p className="page-hero-lead">
                        {courseCount} courses across four colleges. Share your details and
                        our admissions team will guide you through every step — from
                        choosing a course to enrolling.
                    </p>
                </div>
            </section>

            <section className="form-section">
                <div className="container form-grid">
                    <aside className="form-side">
                        <div className="form-side-media">
                            <img src={admissionPicture} alt="Campus" />
                        </div>
                        <div className="form-side-body">
                            <h2 className="form-side-title">Courses you can apply for</h2>
                            {colleges.map((c) => (
                                <div
                                    className="prog-group"
                                    key={c.slug}
                                    style={{ '--accent': `var(--v-${c.slug})` }}
                                >
                                    <a
                                        href={`/colleges/${c.slug}`}
                                        className="prog-group-title seal-type"
                                    >
                                        {c.name}
                                    </a>
                                    <ul className="prog-list">
                                        {c.courses.map((course) => (
                                            <li key={course.id}>
                                                <span className="prog-code">{course.code}</span>
                                                <span className="prog-info">
                                                    <strong>{course.discipline}</strong>
                                                    <span className="figures">{course.duration}</span>
                                                </span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                            <div className="form-side-contact">
                                <a href="mailto:shriguruarjundevjiinstitute@gmail.com">
                                    <FontAwesomeIcon icon={faEnvelope} />
                                    shriguruarjundevjiinstitute@gmail.com
                                </a>
                                <a href="tel:+919899923387">
                                    <FontAwesomeIcon icon={faPhone} />
                                    +91-9899923387
                                </a>
                            </div>
                        </div>
                    </aside>
                    <div className="form-card ee-form">
                        <h2 className="form-title">Enquiry form</h2>
                        <p className="form-sub">
                            Fields marked <span className="req">*</span> are required.
                        </p>
                        <div id="ee-form-3"></div>
                    </div>

                    {/* <div className="form-card">
                        <h2 className="form-title">Enquiry form</h2>
                        <p className="form-sub">
                            Fields marked <span className="req">*</span> are required.
                        </p>

                        {status.state === 'success' && (
                            <div className="alert alert--ok" role="status">
                                <FontAwesomeIcon icon={faCircleCheck} />
                                <span>{status.message}</span>
                            </div>
                        )}
                        {status.state === 'error' && (
                            <div className="alert alert--err" role="alert">
                                <FontAwesomeIcon icon={faTriangleExclamation} />
                                <span>{status.message}</span>
                            </div>
                        )}

                        <form onSubmit={handleSubmit} noValidate>
                            <div className="grid-2">
                                <div className="field">
                                    <label htmlFor="name" className="field-label">
                                        <FontAwesomeIcon icon={faUser} /> Full name <span className="req">*</span>
                                    </label>
                                    <input id="name" name="name" className="input" placeholder="Enter your full name"
                                        value={formData.name} onChange={handleChange} required />
                                </div>
                                <div className="field">
                                    <label htmlFor="email" className="field-label">
                                        <FontAwesomeIcon icon={faEnvelope} /> Email <span className="req">*</span>
                                    </label>
                                    <input id="email" name="email" type="email" className="input" placeholder="you@example.com"
                                        value={formData.email} onChange={handleChange} required />
                                </div>
                                <div className="field">
                                    <label htmlFor="phone" className="field-label">
                                        <FontAwesomeIcon icon={faPhone} /> Phone <span className="req">*</span>
                                    </label>
                                    <input id="phone" name="phone" type="tel" className="input" placeholder="+91-XXXXXXXXXX"
                                        value={formData.phone} onChange={handleChange} required />
                                </div>
                                <div className="field">
                                    <label htmlFor="course" className="field-label">
                                        <FontAwesomeIcon icon={faBookOpen} /> Course <span className="req">*</span>
                                    </label>
                                    <select id="course" name="course" className="input" value={formData.course}
                                        onChange={handleChange} required>
                                        <option value="" disabled>Select a course</option>
                                        {colleges.map((c) => (
                                            <optgroup key={c.slug} label={c.name}>
                                                {c.courses.map((course) => (
                                                    <option key={course.id} value={course.id}>
                                                        {course.name} — {course.duration}
                                                    </option>
                                                ))}
                                            </optgroup>
                                        ))}
                                    </select>
                                </div>
                                <div className="field span-2">
                                    <label htmlFor="message" className="field-label">
                                        <FontAwesomeIcon icon={faMessage} /> Your message
                                    </label>
                                    <textarea id="message" name="message" rows="4" className="input"
                                        placeholder="Tell us about your queries or background"
                                        value={formData.message} onChange={handleChange} />
                                </div>
                            </div>
                            <button type="submit" disabled={isSubmitting} className="btn btn--primary form-submit">
                                {isSubmitting ? (
                                    <><FontAwesomeIcon icon={faSpinner} spin /> Submitting…</>
                                ) : (
                                    <><FontAwesomeIcon icon={faPaperPlane} /> Submit enquiry</>
                                )}
                            </button>
                        </form>
                        <p className="form-foot">
                            <FontAwesomeIcon icon={faLeaf} /> We reply within one working day.
                        </p>
                    </div> */}
                </div>
            </section>
        </>
    );
};

export default AdmissionComponent;
